import { useEffect } from 'react';
import { useDeliveryDashboardStore } from '../stores/deliveryDashboard.store';

const REFRESH_INTERVAL_MS = 30000;

export const useDeliveryDashboard = () => {
  const store = useDeliveryDashboardStore();
  const refresh = useDeliveryDashboardStore((s) => s.refresh);

  useEffect(() => {
    refresh();
    const timer = setInterval(refresh, REFRESH_INTERVAL_MS);
    return () => clearInterval(timer);
  }, [refresh]);

  return store;
};
